<button
  [class.loading]="loading !== undefined ? loading : (loadingService.loading$ | async)"
  class="btn btn-link btn-no-block"
  data-test="refresh"
>
  <fa-icon icon="sync"></fa-icon>
</button>
